import type { GridRowId } from '@thinkalpha/ui-table/types/row';

export interface TableV2LinkingState {
    selectedRowIds: ReadonlySet<GridRowId>;
    linkFilter: string | undefined;
}

export type TableV2LinkingAction =
    | { type: 'SET_SELECTED_ROW_IDS'; selectedRowIds: ReadonlySet<GridRowId> }
    | { type: 'SET_LINK_FILTER'; filter: string | undefined }
    | { type: 'RESET_LINKING' };

function sameRowIds(left: ReadonlySet<GridRowId>, right: ReadonlySet<GridRowId>): boolean {
    return left.size === right.size && left.values().every((rowId) => right.has(rowId));
}

export function tableV2LinkingReducer(state: TableV2LinkingState, action: TableV2LinkingAction): TableV2LinkingState {
    switch (action.type) {
        case 'SET_SELECTED_ROW_IDS':
            if (sameRowIds(state.selectedRowIds, action.selectedRowIds)) return state;
            return { ...state, selectedRowIds: action.selectedRowIds };
        case 'SET_LINK_FILTER':
            if (state.linkFilter === action.filter) return state;
            return { ...state, linkFilter: action.filter };
        case 'RESET_LINKING':
            if (state.selectedRowIds.size === 0 && state.linkFilter === undefined) return state;
            return { selectedRowIds: new Set(), linkFilter: undefined };
        default: {
            const _exhaustiveCheck: never = action;
            return _exhaustiveCheck;
        }
    }
}
